const INITIAL_STATE = {
  tarefa: null,
  esperandoSolicitacao: false,
  esperandoSolicitacaoQtd: 0,
  esperandoConversao: false,
  alerta: {},
  avisosConversao: []
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_CONVERTER_TAREFA_PARA_ATESTMED_INICIAR':
      return { ...state, esperandoConversao: true, alerta: {}, avisosConversao: [], tarefa: action.payload };
    case 'REQUERIMENTO_CONVERTER_TAREFA_PARA_ATESTMED_IMPOSSIBILIDADE':
      return { ...state, esperandoConversao: false, alerta: {}, avisosConversao: action.payload };
    case 'REQUERIMENTO_CONVERTER_CONSULTAR_SERVICO_INICIAR':
    case 'REQUERIMENTO_CONVERTER_ANALISE_DOCUMENTAL_INICIAR':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoConversao: true }
    case 'REQUERIMENTO_CONVERTER_CONSULTAR_SERVICO_FINALIZAR':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoConversao: false }
    case 'REQUERIMENTO_CONVERTER_EXIBIR_ALERTA':
      return { ...state, esperandoConversao: false, alerta: action.payload }
    case 'REQUERIMENTO_CONVERTER_FECHAR_ALERTA':
    case 'REQUERIMENTO_CONVERTER_ANALISE_DOCUMENTAL_SUCESSO':
      return { ...state, esperandoConversao: false, alerta: {} };
    case 'REQUERIMENTO_CONVERTER_ANALISE_DOCUMENTAL_ERRO':
      return { ...state, esperandoSolicitacao: state.esperandoSolicitacaoQtd > 1, esperandoSolicitacaoQtd: Math.max(state.esperandoSolicitacaoQtd - 1, 0), esperandoConversao: false, alerta: { message: action.payload, severity: 'error' } }
    default:
      return state;
  }

}  